<template>
	<div class="special-occasion-wrapper">
		<div class="special-occasion">
			<div class="occasion" :class="{selected: occasion === currentOccasion}" v-for="occasion in occasions" :key="occasion" @click="toggleOccasion(occasion)"><p>{{ getString(occasion) }}</p></div>
		</div>
	</div>
</template>

<script>
import {useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		return {
			getString: languageStore.getString
		}
	},
	name: "SpecialOccation",
	data() {
		return {
			occasions: [
				'birthday',
				'anniversary',
				'honeymoon',
				'business_reason',
				'graduation',
			],
			currentOccasion: null
		}
	},
	methods: {
		toggleOccasion(id) {
			if(this.currentOccasion === id) {
				this.currentOccasion = null;
			} else {
				this.currentOccasion = id;
			}
		}
	}
}
</script>

<style scoped lang="scss">
.special-occasion-wrapper {
	display: flex;
	justify-content: center;
	overflow-x: auto;
	width: 100%;

	.special-occasion {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
		gap: var(--padding-horizontal-s);

		.occasion {
			background-color: var(--theme-bg1-color);
			cursor: pointer;
			border-radius: var(--rounded-corner);
			border: 1px solid var(--business-color-alpha60);
			display: flex;
			align-items: center;
			justify-content: center;
			height: 40px;
			flex: 1;
			width: 170px;
			padding: 0 var(--padding-horizontal-s);
			transition: background-color 0.3s, color 0.3s, border-color 0.3s;

			p {
				color: var(--theme-txt1-color);
				@include truncateString();
			}

			&.selected {

				background-color: var(--business-color-alpha40);
				color: var(--business-text-color);
				border: 1px solid var(--business-color);
			}
		}
	}
}
</style>